export default "__VITE_ASSET__12f1e67f__"